import { Component, ViewChild } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { Utils } from 'src/modules/utils/shared/utils';
import { FrontendField } from '../../netgen/FrontendField';
import { FrontendForm } from '../../netgen/FrontendForm';
import { SmFormComponent } from '../sm-form/sm-form.component';
import { FrontendFieldType } from '../../netgen/FrontendFieldType';
import { Arrays } from 'src/modules/utils/shared/arrays';

@Component({
    selector: 'sm-table-cell-editor',
    templateUrl: './sm-table-cell-editor.component.html',
    styleUrl: './sm-table-cell-editor.component.scss',
    standalone: false
})
export class SmTableCellEditorComponent implements ICellEditorAngularComp {

  form: FrontendForm;
  
  @ViewChild("formComponent")
  formComponent: SmFormComponent;
  
  params: ICellEditorParams;
  isTableEditorPopup = false;

  agInit(params: ICellEditorParams): void {
    this.params = params;
    this.form = new FrontendForm([(params as any).editor as FrontendField]);
    this.form.fields[0].hasLabel = false;
    if (this.form.fields[0].type != FrontendFieldType.table) {
        this.form.fields[0].onValueChanged = () => {
            this.ensureChangedValue();
            this.params.stopEditing();
        };
    }
    this.form.fields[0].tableCellEditor = this;
    this.form.fields[0].value = params.value;
    this.form.fields[0].focus();
    this.isTableEditorPopup = this.form.fields[0].type == FrontendFieldType.table && params.colDef.cellEditorPopup;
  }

  afterGuiAttached(): void {
    this.formComponent?.thisComponentAsTableEditorInited();
  }

  getValue(): any {
    return this.form.fields[0].getValue();
  }

  handleKeyboardEvent(e: KeyboardEvent): void {
    if (e.key == "Tab") {
        e.preventDefault();
        if (e.shiftKey) {
            this.params.api.tabToPreviousCell();
        } 
        else {
            this.params.api.tabToNextCell();
        }
    }
  }

  toNextCell(): void {
 //   Utils.setTimerOnce(100, () => 
   //     this.params.api.startEditingCell({ rowIndex: this.params.rowIndex, colKey: this.params.colDef.colId }));
  }

  close(): void {
    this.ensureChangedValue();
    this.params.stopEditing();
  }

  ensureChangedValue(): void {
    //Andernfalls wird keine Änderung erkannt und valueSetter nicht aufgerufen, wenn der gleiche Wert eingegeben wird wie vorher.
    //Das liegt wahrscheinlich daran, dass die Tabelle denkt, dass sich der Wert nicht geändert hat und deshalb den valueSetter nicht aufruft. 
    //Durch das Setzen eines neuen Arrays wird die Änderung erkannt, auch wenn der Inhalt gleich ist.
    //Projektplanung Gliederungsvorlagentabelle Feld Rollen
    if (Arrays.is(this.form.fields[0].value)) {
        this.form.fields[0].value = [...this.form.fields[0].value];
    }    
  }

}
